import React from 'react';
import { Container, Accordion, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';

const FAQ_COUNT = 12;

function FaqScreen() {
    const { t } = useTranslation();

    return (
        <Container className='py-4'>
            <Row className='justify-content-center'>
                <Col md={9} lg={8}>
                    <h1 className='text-center mb-2' style={{ color: '#FF69B4', fontFamily: 'Georgia, serif' }}>
                        ❓ {t('faq.title')}
                    </h1>
                    <p className='text-center text-muted mb-5'>
                        <Trans i18nKey='faq.subtitle'>
                            Can't find your answer? <Link to='/contact'>Contact us</Link> and we'll be happy to help.
                        </Trans>
                    </p>

                    <Accordion>
                        {Array.from({ length: FAQ_COUNT }, (_, idx) => (
                            <Accordion.Item eventKey={String(idx)} key={idx}>
                                <Accordion.Header>{t(`faq.q${idx + 1}`)}</Accordion.Header>
                                <Accordion.Body className='text-muted'>{t(`faq.a${idx + 1}`)}</Accordion.Body>
                            </Accordion.Item>
                        ))}
                    </Accordion>
                </Col>
            </Row>
        </Container>
    );
}

export default FaqScreen;
